import { render, staticRenderFns } from "./HeXiao.vue?vue&type=template&id=e6a3c254&scoped=true"
import script from "./HeXiao.vue?vue&type=script&lang=js"
export * from "./HeXiao.vue?vue&type=script&lang=js"
import style0 from "./HeXiao.vue?vue&type=style&index=0&id=e6a3c254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a3c254",
  null
  
)

export default component.exports